import 'core-js/stable';

import { ApolloProvider } from '@apollo/client';
import { loadableReady } from '@loadable/component';
import React from 'react';
import { hydrate } from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { useSSR } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';

import 'src/i18n';
import { config } from 'src/config';
import { App } from 'src/modules/app';
import { createClient } from 'src/shared/graphql/client';
import { NonceProvider } from 'src/shared/providers';

const BaseApp = () => {
  useSSR(window.initialI18nStore, window.initialLanguage);

  const client = createClient({
    state: window.initialState,
    uri: config.GRAPHQL_URI,
  });

  return (
    <HelmetProvider>
      <NonceProvider window={window}>
        <BrowserRouter>
          <ApolloProvider client={client}>
            <App />
          </ApolloProvider>
        </BrowserRouter>
      </NonceProvider>
    </HelmetProvider>
  );
};

void loadableReady(() => hydrate(<BaseApp />, document.getElementById('root')));

if (module.hot) {
  module.hot.accept();
}
